var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoctorAvatarDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 400,
    viewBox: "0 0 280 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 400,
    fill: "#3E4654"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78 132C78 98.8629 104.863 72 138 72H142C175.137 72 202 98.8629 202 132V146C202 180.242 174.242 208 140 208V208C105.758 208 78 180.242 78 146V132Z",
    fill: "url(#paint0_linear_2546_18621)",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2497 235.376C90.8661 235.141 91.559 235.225 92.1017 235.6L138.862 267.963C139.547 268.437 140.453 268.437 141.138 267.963L187.929 235.579C188.454 235.215 189.122 235.125 189.726 235.335L242.461 253.75C264.942 261.6 280 282.808 280 306.619V392.605C280 396.689 276.418 400 272 400H8C3.58172 400 0 396.689 0 392.605V308.41C0 285.194 14.3256 264.385 36.0133 256.098L90.2497 235.376Z",
    fill: "url(#paint1_linear_2546_18621)",
    fillOpacity: 0.24
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2546_18621",
    x1: 140,
    y1: 68.1254,
    x2: 140,
    y2: 199.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2546_18621",
    x1: 140,
    y1: 223.1,
    x2: 140,
    y2: 389.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorAvatarDefault);
export default __webpack_public_path__ + "static/media/doctor_avatar_default.63f0628bccf11a4d966b6fc0da061709.svg";
export { ForwardRef as ReactComponent };